import { cloudFromAccountKey } from '../tenancy/cloud-account.js';
export const COST_SOURCES = {
    aws: {
        name: 'AWS Cost Explorer',
        lag: 'Cost Explorer lags about a day.',
        charged: 'Cost Explorer charges the account being read about a cent per request, so it happens when you ask.',
        unattributed: 'The EKS control plane, NAT and data transfer, anything shared between instances, and anything made outside Terraform.',
    },
    /*
     * Microsoft's own figures, from "Understand Cost Management data": 8 to 24
     * hours on an Enterprise Agreement or Microsoft Customer Agreement, up to 72
     * on pay-as-you-go, refreshed about every four hours, and estimated until the
     * invoice. Which agreement a subscription is under is not something Reader
     * shows, so the sentence gives both.
     */
    azure: {
        name: 'Azure Cost Management',
        lag: 'Azure Cost Management lags 8 to 24 hours, and up to 72 on a pay-as-you-go subscription; the open month is an estimate until it is invoiced.',
        charged: 'Cost Management does not charge for a read, but limits how many Qrvey may make, so it happens when you ask.',
        // Azure reads a tag only from the resource billed, never its group, and
        // some resource types report none in usage ("How tags are used in cost
        // and usage data").
        unattributed: 'Anything billed without the qrvey-id tag on the resource itself: resource types that report no tags to billing, anything shared between instances, and anything made outside Terraform.',
    },
};
/**
 * The lag sentence for a set of accounts, one per cloud among them.
 *
 * For a screen that sums several accounts, such as the fleet's Cost tab. An
 * empty set says nothing rather than guessing which cloud it would have been.
 */
export const costLagFor = (clouds) => [...new Set(clouds)]
    .sort()
    .map((cloud) => COST_SOURCES[cloud].lag)
    .join(' ');
/** The source of one account's figures, read off its key; undefined for a key no cloud claims. */
export const costSourceOf = (accountKey) => {
    const cloud = cloudFromAccountKey(accountKey);
    return cloud === undefined ? undefined : COST_SOURCES[cloud];
};
/** `costLagFor` over the clouds some account keys name. */
export const costLagForAccounts = (accountKeys) => costLagFor([...accountKeys].flatMap((key) => {
    const cloud = cloudFromAccountKey(key);
    return cloud === undefined ? [] : [cloud];
}));
//# sourceMappingURL=source.js.map